import { apiRoutes } from "@constants/api-routes";
import { handleRequest } from "@utils/http-util";
import { injectRpServiceId } from "@utils/parameter-injector";
import { RequestTypes } from "@enums/request-types";
import { VerificationServiceConfiguration } from "@idw-types/data/verification-service-configuration";

export const exportRpServiceConfigurationRequest = async (
    rpServiceId: string
): Promise<{ data: VerificationServiceConfiguration, error: any }> => {
    const route = injectRpServiceId(apiRoutes.serviceConfiguration.rpServiceConfig.rpService.export, rpServiceId);
    const { data, error } = await handleRequest(RequestTypes.GET, route);
    return { data, error };
};